export default function SecureIcon() {
  return (
    <>
      <path
        d='M3 6.45665C6.23628 6.45665 9.31265 4.81888 10.4463 4C13.2243 6.07014 16.6396 6.50032 18 6.45665V12.4836C17.3126 17.5672 12.6778 20.2794 10.4463 21C4.63246 19.0085 3.05967 14.4926 3 12.4836V6.45665Z'
        fill='#4D7225'
      />
      <path
        d='M8.0154 11.7079L10.2308 13.9233L13.9231 10.231'
        stroke='white'
        strokeWidth='1.47692'
      />
    </>
  );
}
